import { Box } from '@mui/system';
import RolePermissionsForm from './role-permissions-form';
import { useQuery } from '@tanstack/react-query';
import { getAllRolesQuery } from '../../../../api/users-api';
import { useParams } from 'react-router-dom';
import { useUserSettings } from '../../../../utils/use-user-settings';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

export default function RolePermissionsPage() {
  const { roleName } = useParams() as { roleName: string };
  const { changeLogRoles } = useUserSettings();
  const { data: roles, isLoading } = useQuery(getAllRolesQuery());
  const currentRole = roles?.find((role) => role.roleName === roleName);

  if (isLoading || !currentRole) {
    return (
      <Box component="form" sx={{ position: 'relative', height: '100%' }}>
        <Stack
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
          gap={1}
          sx={{ position: 'absolute', top: -50, right: -15 }}
        >
          <Button
            variant="contained"
            disabled={true}
            sx={{ position: 'absolute', top: 0, right: 0 }}
            type="submit"
          >
            Save
          </Button>
        </Stack>
        <Stack
          height={300}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Stack>
      </Box>
    );
  }

  return (
    <RolePermissionsForm role={currentRole} changeLogRoles={changeLogRoles} />
  );
}
